

import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component({
    components: {

    },
})
export default class CircleProgressHeader extends Vue {
    @Prop({ type: String, default: null }) readonly name!: string;
}
